import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { User } from '../_models';
import { ResetPassword } from '../_models';
import { AlertService, AuthenticationService, UserService } from '../_services';
import { isNullOrUndefined } from 'util';
import { first } from 'rxjs/operators';
import { Configuration } from '../configuration/configurations';  
@Component({
  selector: 'app-resetpassword',
  templateUrl: './resetpassword.component.html',
  providers: [UserService, AlertService],
  styleUrls: ['./resetpassword.component.scss']
})
export class ResetpasswordComponent implements OnInit {
  loginForm: FormGroup;
  loading = false;
  submitted = false;
  key: string;
  userName: any;
  resetPassword:ResetPassword;
  errorMsg: string = "";
  dnsname:string;
    logoimage:string;
    isFromDns:boolean=false;
    private subhostname:any;
    private siteUrl:any="";
    private themeWrapper = document.querySelector('body');
  constructor(private formBuilder: FormBuilder,private route: ActivatedRoute,private router: Router,private userService: UserService,private authenticationService: AuthenticationService,private alertService: AlertService,private _configuration: Configuration,private userservice:UserService) { }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      password: ['', [Validators.required,Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/)]],
      confirmpassword: ['', [Validators.required,Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/)]],
      recaptcha: ['', Validators.required]
  });
  this.userName = JSON.parse(localStorage.getItem('resetemail'));

  // reset login status
  this.authenticationService.logout();

  // get return url from route parameters or default to '/'
  this.key = this.route.snapshot.queryParams['key'];
  //this.key=this.route.snapshot.paramMap.get("animal")
  if(this.key == "" || this.key==null){
    this.router.navigate(['/login']);
  }
  else
  {

this.authenticationService.GetUserDetailByUserKey(this.key)
        .pipe(first())
        .subscribe(
            response => {
              if(response["StatusCode"]=="200"){
                let data=response["Data"];
                if (response != null) {
                  this.userName=data.UserName;
                }
                else {
                   this.alertService.showNotification('error','Email is not valid')
                }
              }
              else{
                this.alertService.showNotification('error','Email is not valid')
              }
        localStorage.removeItem("PrimaryColor");
        localStorage.removeItem("SecondaryColor");
        localStorage.removeItem("BodyBackGround");
        localStorage.removeItem("DnsName");
        localStorage.removeItem("clientLogo");
        localStorage.removeItem("isfromDns");
        localStorage.removeItem("ReselerUrl");
        this.themeWrapper.classList.remove("bodybackground");
        this.themeWrapper.style.removeProperty('--colorPrimary');
        this.themeWrapper.style.removeProperty('--colorSecondary');
        // reset login status
        this.authenticationService.logout();

        //this.dnsname = this.route.snapshot.queryParams['dns'];
        if(this._configuration._local)
        {
            this.siteUrl=new URL(this._configuration._subdomainhost);
        }
        else
        {
         this.siteUrl=window.location;
        }
        // this.subhostname= this.siteUrl.host;
        // let idx = this.subhostname.indexOf('.com');
        // let sec = this.subhostname.substring(0, idx - 1).lastIndexOf('.');
        // var rootDomain = this.subhostname.substring(sec + 1);
        // this.subhostname = this.subhostname.replace(rootDomain, "");
        // this.subhostname = this.subhostname.replace(".", "");
        // if(this.subhostname != ""){
        // //if(this.route.snapshot.queryParams['dns']){
        //   this.userservice.GetClientDetailByDns(this.subhostname)
        //   .pipe(first()).subscribe(
        //       response => {
        //           let data=response["Data"];
    
        //                if(response["StatusCode"]=="200")
        //                {
        //                 this.isFromDns=true;
        //                   console.log("Client Dns Data",data["Data"]);
        //                   if(data["PrimaryColor"])
        //                   {
        //                     localStorage.setItem("PrimaryColor",data["PrimaryColor"])
        //                     this.themeWrapper.style.setProperty('--colorPrimary',data["PrimaryColor"] );
        //                   }
        //                   if(data["SecondaryColor"])
        //                   {
        //                     localStorage.setItem("SecondaryColor",data["SecondaryColor"])
        //                     this.themeWrapper.style.setProperty('--colorSecondary',data["SecondaryColor"] );
        //                   }

        //                   if(data["Logo"])
        //                   {
        //                       localStorage.setItem("clientLogo",data["Logo"]);
        //                       this.logoimage=data["Logo"];
        //                   }
        //                   localStorage.setItem("isfromDns","true");
        //                   localStorage.setItem("ReselerUrl",this.siteUrl.origin);
        //                   this.themeWrapper.classList.add("bodybackground");
        //                   localStorage.setItem("BodyBackGround","true");
        //                   localStorage.setItem("DnsName",data["DNS"]);
        //                   this.loading=false;
        //                }
        //               },
        //                error => {
        //               //         this.alertService.showNotification('error',"Some thing went wrong.")
        //                 //       this.loading = false;
        //                }
        //                );
        // }
            },
            error => {
                this.alertService.showNotification('error','Email is not valid')
                this.loading = false;
            });
  }

  }
  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }

  onSubmit() {
      this.submitted = true;
      
      // stop here if form is invalid
      if (this.loginForm.invalid) {
        if(this.f.recaptcha.invalid){
          this.alertService.showNotification('error','Please verify captcha.');
      }
          return;
      }

      if (this.loginForm.value.password != this.loginForm.value.confirmpassword) {
        this.alertService.showNotification('error','Both fields must have same value.')
          return;
      }

      this.loading = true;
   
      this.loading = true;
      this.resetPassword={
        Password:this.loginForm.value.password,
        UserName:this.userName
      };
      this.userService.savePassword(this.resetPassword)
          .pipe(first())
          .subscribe(
              data => {
                if(data==true){
                  this.alertService.showNotification('success','Your password has been reset.');
                  this.loading = false;
                  localStorage.removeItem('resetemail');
                  this.authenticationService.login(this.userName, this.loginForm.value.password)
                  .pipe(first()).subscribe(response => {
                      if (response != null) {
                        console.log("doli", response);
                        localStorage.removeItem("PrimaryColor")
                        this.themeWrapper.style.removeProperty('--colorPrimary');
                        localStorage.removeItem("SecondaryColor")
                        this.themeWrapper.style.removeProperty('--colorSecondary');
                        localStorage.removeItem("clientLogo");
                        localStorage.setItem('currentUser', JSON.stringify(response));
                     
                        let access_token = response['access_token'];
                        let token_type = response['token_type'];
                        let expires_in = response['expires_in'];
                        let role = response['roleName'];
                        let user = response['User'];
                        let username= response['UserName'];
                        let displayname = response['DisplayName'];
                        let clientcode = response['ClientCode'];
                        let ClientName=response["ClientName"];
                        let rate = response['Rate'];
                        let Extensions=response["Extensions"];
                        let clientlogo=response["Logo"];
                        let clientPrimaryColor=response["PrimaryColor"];
                        let clientSecondaryColor=response["SecondaryColor"];
                        let dnsName=response["DnsName"];
                        console.log("Client Primary Color",clientPrimaryColor)
                        console.log("Client Secondary Color",clientSecondaryColor)
                        localStorage.setItem("Authorization", JSON.stringify(token_type + ' ' + access_token));
                        localStorage.setItem("role", role);
                        localStorage.setItem("user", user);
                        localStorage.setItem("userName", username);
                        localStorage.setItem("displayName", displayname);
                        localStorage.setItem("clientcode", clientcode);
                        localStorage.setItem("rate", rate);
                        localStorage.setItem("Extensions", Extensions);
                        localStorage.setItem("ClientName", ClientName);
                        if(clientPrimaryColor)
                        {
                          localStorage.setItem("PrimaryColor",clientPrimaryColor)
                          //this.themeWrapper.style.setProperty('--bgPrimary',clientPrimaryColor);
                        }
                        if(clientSecondaryColor)
                        {
                          localStorage.setItem("SecondaryColor",clientSecondaryColor)
                          //this.themeWrapper.style.setProperty('--bgSecondary',clientSecondaryColor);
                        }
                        if(clientlogo)
                        {
                            localStorage.setItem("clientLogo", clientlogo);
                        }
                        
                        localStorage.setItem("clientPrimaryColor", clientPrimaryColor);
                        localStorage.setItem("clientSecondaryColor", clientSecondaryColor);
                          //window.location.href = this._configuration.baseUrlToken + "/dashboard";
                          if(dnsName!=""){
                            let urlwithdns=this._configuration.baseUrlToken;
                            localStorage.setItem("isfromDns","true");
                            localStorage.setItem("DnsName",dnsName);
                            localStorage.setItem("ReselerUrl",urlwithdns.replace("www",dnsName))
                        }
                        if(localStorage.getItem("ReselerUrl"))
                        {  
                            //localStorage.setItem('currentUser', JSON.stringify(response));
                            window.location.href = localStorage.getItem("ReselerUrl") + "/dashboard?authdata="+btoa(JSON.stringify(response));
                        }
                        else
                        {
                            window.location.href = this._configuration.baseUrlToken + "/dashboard";
                        }
                      }
                      else {
                        this.alertService.showNotification('error','Email and password combination is incorrect.')
                      }
                  },
                      error => {
                        this.alertService.showNotification('error','Email and password combination is incorrect.')
                      });
                  //this.router.navigate(['/revocodemo/dashboard']);
                 
                }else{
                  this.alertService.showNotification('error',"Error in reset password");
                }
              },
              error => {
                  //this.alertService.error(error);
                  this.alertService.showNotification('error','Error in reset password');
                  this.loading = false;

              });
  }

}
